// modules
import { createAction } from 'redux-actions'

// actions
export const setEnrollmentReportList = createAction(
  'SET_ENROLLMENT_REPORT_LIST'
)
export const setEnrollmentReportPredefinedFilter = createAction(
  'SET_ENROLLMENT_REPORT_PREDEFINED_FILTER'
)

export const resetEnrollmentReport = createAction('RESET_ENROLLMENT_REPORT')
